
import Vue from "vue";
export default Vue.extend({
  props: ["pics"],
  data() {
    return {
      imagePic: "",
      dialogTableVisible: false,
    };
  },
  methods: {
    picClick(pic: any) {
      this.imagePic = pic;
      this.dialogTableVisible = true;
    },
  },
});
